// @ts-nocheck
import { sendToShell } from "@insite/client-framework/Components/ShellHole";
import { fetch } from "@insite/client-framework/ServerSideRendering";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { CreateSessionApiParameter, Session } from "@insite/client-framework/Services/SessionService";
import { SessionModel } from "@insite/client-framework/Types/ApiModels";

const sessionsUrl = "/api/v1/sessions";

/* Store Custom Code - Start */
export interface StoreCreateSessionApiParameter extends CreateSessionApiParameter {
    /** Single-use ticket proving email-OTP MFA was passed; sent as the X-Mfa-Ticket header. */
    mfaTicket?: string;
}
/* Store Custom Code - End */

/**
 * Store override of the client-framework `createSession` that additionally forwards a single-use
 * email-OTP MFA ticket as the `X-Mfa-Ticket` header. Mirrors the out-of-the-box behavior otherwise.
 */
export async function createSession(parameter: StoreCreateSessionApiParameter): Promise<ServiceResult<Session>> {
    /* Store Custom Code - Start */
    const { accessToken, mfaTicket, ...otherProps } = parameter;

    const headers = getHeader(accessToken);
    if (mfaTicket) {
        headers["X-Mfa-Ticket"] = mfaTicket;
    }
    /* Store Custom Code - End */

    const response = await fetch(sessionsUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(otherProps),
    });

    if (response.status < 200 || response.status >= 300) {
        let errorMessage: string;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            const errorJson = (await response.json()) as { message: string };
            errorMessage = errorJson.message;
        } else {
            errorMessage = await response.text();
        }
        return {
            successful: false,
            errorMessage,
            statusCode: response.status,
        };
    }

    const sessionModel = await (response.json() as Promise<SessionModel>);
    cleanSession(sessionModel);
    informShell(sessionModel);
    return {
        successful: true,
        result: sessionModel,
    };
}

function cleanSession(session: SessionModel) {
    if (session.billTo) {
        (session as Session).billToId = session.billTo.id;
        session.billTo = null;
    }

    if (session.shipTo) {
        (session as Session).shipToId = session.shipTo.id;
        session.shipTo = null;
    }
}

function informShell(session: SessionModel) {
    sendToShell({
        type: "FrontEndSessionLoaded",
        personas: session.personas,
    });
}

function getHeader(accessToken: string | undefined) {
    const header: Record<string, string> = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
    };

    if (accessToken) {
        header["authorization"] = `Bearer ${accessToken}`;
    }

    return header;
}
